import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { OverlayPanel } from 'primeng/overlaypanel';
import { NavService } from '../../../_services/_nav.service';
import { AutenticacionService } from '../../../_services/autenticacion.service';
import { MetaVentaSegurosService } from '../../../_services/meta-venta-seguros.service';
import { MetaVentaSeguros } from '../../../_models/meta-venta-seguros';
import { AppSettingService } from '../../../_services/app-setting.service';

const MAX_LENGTH = 50;
@Component({
  selector: 'app-meta-venta-seguros',
  templateUrl: './meta-venta-seguros.component.html',
  styleUrls: ['./meta-venta-seguros.component.css']
})
export class MetaVentaSegurosComponent implements OnInit {
  carInformacionInicial = true;
  submitted = false;
  guardando = false;
  formulario: FormGroup;
  metaVenta: MetaVentaSeguros;
  mensajeTooltip: string;
  constructor(
    private navServicio: NavService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private fb: FormBuilder,
    private autServicio: AutenticacionService,
    private conServicio: ConfirmationService,
    private metaVentaSeguroService: MetaVentaSegurosService,
    public appSettingService: AppSettingService
  ) { }

  ngOnInit() {
    this.cargaInicial();
  }

  cargaInicial() {
    this.metaVentaSeguroService.listado().subscribe((metasVenta) => {
      this.metaVenta = metasVenta.length > 0 ? metasVenta[0] : null;
      this.cargarFormulario();
      this.carInformacionInicial = false;
    });
  }

  cargarFormulario() {
    this.formulario = this.fb.group({
      idMetaVentaSeguro: [this.metaVenta ? this.metaVenta.idMetaVentaSeguro : null],
      valorMinimoPrima: [this.metaVenta ? this.metaVenta.valorMinimoPrima : null, [Validators.required]],
      numeroPolizaUnidadCredito: [this.metaVenta ? this.metaVenta.numeroPolizaUnidadCredito : null, [Validators.required]],
      descripcion: [this.metaVenta ? this.metaVenta.descripcion : null, [Validators.required]],
      indicadorHabilitado: [this.metaVenta ? this.metaVenta.indicadorHabilitado : false, [Validators.required]],
    });
  }

  get f() {
    return this.formulario.controls;
  }

  async onSubmit() {
    this.submitted = true;
    if (this.formulario.valid) {
      this.guardando = true;
      const registro = this.formulario.getRawValue();
      await this.crearActualizarMetaVenta(registro);
    }
  }

  async crearActualizarMetaVenta(registro: MetaVentaSeguros) {
    if (registro.idMetaVentaSeguro) {
      this.metaVenta.valorMinimoPrima = registro.valorMinimoPrima;
      this.metaVenta.numeroPolizaUnidadCredito = registro.numeroPolizaUnidadCredito;
      this.metaVenta.descripcion = registro.descripcion;
      this.metaVenta.indicadorHabilitado = registro.indicadorHabilitado;
      const res = await this.metaVentaSeguroService.actualizar(this.metaVenta).toPromise();
      this.navServicio.setMesage( 2 );
      this.guardando = false;
    } else {
      const res = await this.metaVentaSeguroService.agregar(registro).toPromise();
      this.navServicio.setMesage( 1 );
      this.guardando = false;
    }

  }

  verInfo(toogle: OverlayPanel, event) {
    this.mensajeTooltip = 'Nota: El mensaje que se describa en el campo anterior será reflejado para los usuarios desde la pantalla de oferta y seguros para que puedan tener en cuenta esta información.';
    toogle.toggle(event);
  }

  textChanged($event) {
    if ($event.editor.getLength() > MAX_LENGTH) {
      $event.editor.deleteText(MAX_LENGTH, $event.editor.getLength());
    }
  }

  regresar(dirty: boolean) {
    if (dirty) {
      this.conServicio.confirm({
        message: this.navServicio.buscarMensaje('MSG_CANCELARCAMBIOS'),
        header: this.navServicio.buscarMensaje('LBL_CONFIRMACION'),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      });
    } else {
      this.location.back();
    }
  }

}
